import React from 'react';

import { queryParam } from '../../core/utils/queryParam.js';

export function MerchantPricingTable() {
  const uuid = queryParam('uuid');
  const email = queryParam('email');

  return (
    <div style={{ height: 'fit-content', padding: "20px 0", backgroundColor: 'rgb(51, 51, 54)' }}>
      <stripe-pricing-table
        pricing-table-id={window.STRIPE_PRICING_TABLE_ID}
        publishable-key={window.STRIPE_PRICING_KEY}
        customer-email={email}
        client-reference-id={uuid}
      ></stripe-pricing-table>
    </div>
  );
}
